import React from "react";
import { Link } from "react-router-dom";
import "../styles/SuccessPage.css";

export const SuccessPage: React.FC = () => {
  return (
    <div className="success-page">
      <div className="success-content">
        <h1>Резервацията е успешна!</h1>
        <p>Благодарим Ви за резервацията. Ще се свържем с Вас скоро.</p>
        <Link to="https://nameren-rai.com" className="back-button">
          Към начална страница
        </Link>
      </div>
    </div>
  );
};
